import { Steps } from "antd"
import { useTranslation } from "react-i18next"
import { mapPosition } from "../../utils/mappers"
import { setValveMode } from "../../api/Cards"

const ProgramStepper = ({ steps, currentStep, progressStep, percent, metaData, style = {} }) => {
    const { t } = useTranslation()
    const handleDirectStepChange = (positionID) =>
    {
        console.log("Valve control ", { MetaData: metaData, ValveIndex: positionID })
        setValveMode({MetaData: metaData, ValveIndex: positionID})
    }

    return (
        <>
            <Steps
                className="pd-custom-step"
                current={currentStep}
                labelPlacement="vertical"
                style={style}
                //percent={progressStep === currentStep ? percent : 0}
            >
                {steps.map(({ positionID, timespan }, index) => (
                    <Steps.Step
                        key={index}
                        title={t(`general.filter.valve.position.${mapPosition(positionID)}`)}
                        description={timespan > 0 ? `${timespan} min` : ''}
                        onClick={(e) => handleDirectStepChange(positionID)}
                    />
                ))}
            </Steps>
        </>
    )
}
export default ProgramStepper
